import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import SendPoints from './sections/SendPoints/SendPoints';
import CustomEmptyPage from '../../../shared/components/CustomEmptyPage/CustomEmptyPage';
import { RewardsContext } from '../../../shared/context/rewards/rewardsContext';
import { TRANSLATION_POINTS } from '../../../shared/translations/rewards';
import { TRANSLATIONS_SETTINGS } from '../../../shared/translations/settings';
import RewardsHero from '../sections/RewardsHero/RewardsHero';
import RewardsPointsTabBar from '../sections/RewardsPointsTabBar/RewardsPointsTabBar';

import '../Rewards.scss';

const RewardsPoints = () => {
  const { error: rewardsError } = useContext(RewardsContext);
  const { t } = useTranslation();

  return (
    <div className="rewards-page-container" data-experience="new">
      <div className="rewards-header">
        <RewardsHero title={t(TRANSLATION_POINTS.header.heroTitle)} />
        <div className="rewards-tabs">
          <div className="tabbar flex flex-row">
            <RewardsPointsTabBar />
          </div>
        </div>
      </div>
      <div className="rewards-content">
        {rewardsError ? (
          <CustomEmptyPage
            title={t(TRANSLATIONS_SETTINGS.error.title)}
            subtitle={t(TRANSLATIONS_SETTINGS.error.subtitle)}
            newExperience={true}
          />
        ) : (
          <SendPoints />
        )}
      </div>
    </div>
  );
};

export default RewardsPoints;
